import axios from "../axios"
import apiUrls from "../urls"

export default {
	fetchRegister (data) {
		return axios.post(apiUrls.register, data)
	},
	sendRegisterRequest (data) {
		return axios.post(apiUrls.startRegisteration, data)
	},
	sendConfirmCode (data) {
		return axios.post(apiUrls.confirmEmail, data)
    },
    startResetPwd (data) {
        return axios.post(apiUrls.resetPassword, data)
    },
    updatePassword (data) {
        return axios.post(apiUrls.updatePassword, data)
    },
    checkResetToken (data) {
        return axios.post(apiUrls.checkResetToken, data)
    }
}
